"use strict";

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var eth_sdk_1 = require("eth-sdk");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var defaults_1 = require("./defaults");

var globals_1 = require("./globals");

var clients_1 = require("./clients");

var contracts_1 = require("./contracts");

var modules_1 = require("./modules");

var utils_1 = require("./utils");

var Sdk = /*#__PURE__*/function () {
  function Sdk() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Sdk);

    this.error$ = new utils_1.ErrorSubject();
    this.clients = null;
    this.contracts = null;
    this.modules = null;
    options = Object.assign({
      queryProviderEndpoint: 'http://localhost:8545',
      fetch: globals_1.GLOBAL_FETCH,
      WebSocket: globals_1.GLOBAL_WEB_SOCKET,
      chainId: 0,
      networkVersion: 0
    }, options);
    var _options = options,
        queryProviderEndpoint = _options.queryProviderEndpoint,
        fetch = _options.fetch,
        WebSocket = _options.WebSocket,
        chainId = _options.chainId,
        networkVersion = _options.networkVersion;

    if (!fetch) {
      new Error('fetch not found. Please use `node-fetch` via options.fetch');
    }

    if (!WebSocket) {
      new Error('WebSocket not found. Please use `ws` via options.WebSocket');
    }

    this.connectionOptions = {
      fetch: fetch,
      WebSocket: WebSocket
    }; // query

    {
      var provider;

      switch (queryProviderEndpoint.slice(0, 2)) {
        case 'ws':
          provider = new eth_sdk_1.queryProviders.WebSocketProvider(queryProviderEndpoint, {
            webSocketConstructor: WebSocket
          });
          break;

        case 'ht':
          provider = new eth_sdk_1.queryProviders.HttpProvider(queryProviderEndpoint, {
            fetch: fetch
          });
          break;

        default:
          throw new Error('invalid query provider endpoint');
      }

      this.query = new eth_sdk_1.Query(provider);
    }
    this.state$ = new Sdk.State$({
      networkVersion: networkVersion,
      chainId: chainId
    }); // clients

    {
      var _options2 = options,
          kChannelsClient = _options2.kChannelsClient,
          platformClient = _options2.platformClient,
          relayerClient = _options2.relayerClient;
      var kChannels = kChannelsClient ? new clients_1.KChannelsClient(kChannelsClient, this.connectionOptions) : null;
      var platform = platformClient ? new clients_1.PlatformClient(platformClient, this.connectionOptions) : null;
      var relayer = relayerClient ? new clients_1.RelayerClient(relayerClient, this.connectionOptions) : null;
      this.clients = {
        kChannels: kChannels,
        platform: platform,
        relayer: relayer
      };
    } // modules

    {
      var _options3 = options,
          authKeyModule = _options3.authKeyModule;
      var accountAuthKey = new modules_1.AccountAuthKeyModule();
      var account = new modules_1.AccountModule(this);
      var authKey = new modules_1.AuthKeyModule(authKeyModule || {});
      var batch = new modules_1.BatchModule(this);
      var block = new modules_1.BlockModule(this);

      var _kChannels = new modules_1.KChannelsModule(this);

      var notification = new modules_1.NotificationModule(); // sync states

      this.state$.accountAuthKey$ = accountAuthKey.state$;
      this.state$.account$ = account.state$;
      this.state$.authKey$ = authKey.state$;
      this.state$.batch$ = batch.state$;
      this.state$.block$ = block.state$;
      this.state$.kChannels$ = _kChannels.state$;
      this.state$.notification$ = notification.state$;
      this.modules = {
        accountAuthKey: accountAuthKey,
        account: account,
        authKey: authKey,
        batch: batch,
        block: block,
        kChannels: _kChannels,
        notification: notification
      };
    }
    this.initialized = this.initialize(); // binds methods

    {
      var methodNames = Object.getOwnPropertyNames(Sdk.prototype);
      var self = this;

      var _iterator = _createForOfIteratorHelper(methodNames),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var methodName = _step.value;

          switch (methodName) {
            case 'constructor':
            case 'state':
            case 'initialize':
            case 'bindMethod':
            case 'require':
              break;

            default:
              self[methodName] = this.bindMethod(self[methodName]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  _createClass(Sdk, [{
    key: "createAccount",
    // account
    value: function createAccount() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result, account;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.require({
                  account: false,
                  platform: true
                });

                result = null;
                account = this.modules.account;

                if (!address) {
                  _context.next = 12;
                  break;
                }

                address = eth_sdk_1.toChecksumAddress(address);

                if (address) {
                  _context.next = 7;
                  break;
                }

                throw new Error('invalid address');

              case 7:
                _context.next = 9;
                return account.createFromAddress(address);

              case 9:
                result = _context.sent;
                _context.next = 15;
                break;

              case 12:
                _context.next = 14;
                return account.createFromAuthKey();

              case 14:
                result = _context.sent;

              case 15:
                return _context.abrupt("return", result);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "resetAccount",
    value: function resetAccount() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var account;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.require({
                  account: true
                });

                account = this.modules.account;
                account.reset();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getAccountAuthKeys",
    value: function getAccountAuthKeys() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.require({
                  account: true,
                  platform: true
                });

                return _context3.abrupt("return", this.clients.platform.getAccountAuthKeys({
                  account: this.modules.account.address,
                  page: page
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getAccountEvents",
    value: function getAccountEvents() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.require({
                  account: true,
                  platform: true
                });

                return _context4.abrupt("return", this.clients.platform.getAccountEvents({
                  page: page,
                  account: this.modules.account.address
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    } // kChannels

  }, {
    key: "kChannelsAuthenticate",
    value: function kChannelsAuthenticate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.require({
                  account: true,
                  kChannels: true
                });

                return _context5.abrupt("return", this.modules.kChannels.authenticate());

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "kChannelsCreate",
    value: function kChannelsCreate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.require({
                  account: true,
                  kChannels: true
                });

                return _context6.abrupt("return", this.modules.kChannels.createChannel());

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "kChannelsDeposit",
    value: function kChannelsDeposit(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.require({
                  account: true,
                  kChannels: true,
                  relayer: true
                });

                _context7.next = 3;
                return this.resetBatch();

              case 3:
                _context7.next = 5;
                return this.batchExecuteAccountTransaction({
                  value: options.value,
                  recipient: options.recipient ? options.recipient : eth_sdk_1.toChecksumAddress(this.clients.kChannels.depositAddress),
                  data: options.data
                });

              case 5:
                _context7.next = 7;
                return this.estimateBatch();

              case 7:
                return _context7.abrupt("return", this.submitBatch());

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "kChannelsTransact",
    value: function kChannelsTransact(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.require({
                  account: true,
                  kChannels: true
                });

                return _context8.abrupt("return", this.modules.kChannels.transact(options));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "kChannelsWithdraw",
    value: function kChannelsWithdraw(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.require({
                  account: true,
                  kChannels: true
                });

                return _context9.abrupt("return", this.modules.kChannels.withdraw(options));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "kChannelsInitialized",
    value: function kChannelsInitialized() {
      return !!this.clients.kChannels;
    } // payments

  }, {
    key: "getAccountDeposit",
    value: function getAccountDeposit() {
      var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.require({
                  account: true,
                  platform: true
                });

                return _context10.abrupt("return", this.clients.platform.getAccountDeposit({
                  token: token,
                  account: this.modules.account.address
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "subscribeAccountDeposit",
    value: function subscribeAccountDeposit() {
      var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var platform, _this$modules$account, address, externalDepositAddress, value, result, subject;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.require({
                  account: true,
                  platform: true
                });

                platform = this.clients.platform;
                _this$modules$account = this.modules.account.state, address = _this$modules$account.address, externalDepositAddress = _this$modules$account.externalDepositAddress;

                if (!token) {
                  token = eth_sdk_1.ZERO_ADDRESS;
                }

                _context11.next = 6;
                return this.clients.platform.getAccountDeposit({
                  token: token,
                  account: address
                });

              case 6:
                value = _context11.sent;
                result = new utils_1.UniqueSubject(value);
                platform.subscribeAccountDepositUpdated({
                  account: address
                }).filter(function (value) {
                  return value && value.token === token;
                }).subscribe(function (value) {
                  return result.next(value);
                });

                if (token) {
                  _context11.next = 14;
                  break;
                }

                _context11.next = 12;
                return this.subscribeBalance({
                  address: externalDepositAddress
                });

              case 12:
                subject = _context11.sent;
                subject.pipe(operators_1.filter(function (value) {
                  return !!value;
                }), operators_1.filter(function (externalAmount) {
                  return !externalAmount.eq(result.getValue().externalAmount);
                }), operators_1.map(function (externalAmount) {
                  var value = result.getValue();
                  return Object.assign(Object.assign({}, value), {
                    availableAmount: value.internalAmount.add(externalAmount).sub(value.lockedAmount),
                    externalAmount: externalAmount
                  });
                })).subscribe(result);

              case 14:
                return _context11.abrupt("return", result);

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getAccountPaymentChannels",
    value: function getAccountPaymentChannels() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.require({
                  account: true,
                  platform: true
                });

                return _context12.abrupt("return", this.clients.platform.getAccountPaymentChannels({
                  account: this.modules.account.address,
                  page: page
                }));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "getPaymentChannel",
    value: function getPaymentChannel(hash) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.require({
                  platform: true
                });

                return _context13.abrupt("return", this.clients.platform.getPaymentChannel({
                  hash: hash
                }));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "updatePaymentChannel",
    value: function updatePaymentChannel(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var recipient, token, uidBase, amount, sender, uid, messageHash, senderSignature;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.require({
                  account: true,
                  platform: true
                });

                recipient = options.recipient, token = options.token;
                uidBase = options.uidBase, amount = options.amount;
                recipient = eth_sdk_1.toChecksumAddress(recipient);
                token = eth_sdk_1.toChecksumAddress(token) || eth_sdk_1.ZERO_ADDRESS;
                sender = this.modules.account.address;
                uid = eth_sdk_1.soliditySha3(uidBase || 'default');
                messageHash = eth_sdk_1.soliditySha3(this.contracts.accountRegistry.address, this.state.chainId, this.contracts.accountRegistry.getMethodSignature('commitAccountPaymentChannel'), sender, recipient, token, uid, amount);
                _context14.next = 10;
                return this.modules.authKey.signPersonalMessage(messageHash);

              case 10:
                senderSignature = _context14.sent;
                return _context14.abrupt("return", this.clients.platform.updatePaymentChannels({
                  recipient: recipient,
                  token: token,
                  uid: uid,
                  sender: sender,
                  senderSignature: senderSignature,
                  amount: amount
                }));

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    } // batch

  }, {
    key: "batchMoveFundsToAccountDeposit",
    value: function batchMoveFundsToAccountDeposit(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var accountRegistry, batch;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.require({
                  account: true,
                  relayer: true
                });

                accountRegistry = this.contracts.accountRegistry;
                batch = this.modules.batch;
                return _context15.abrupt("return", batch.addToBatch(function (commonAccountOptions) {
                  return accountRegistry.buildMoveFundsToAccountDepositData(Object.assign(Object.assign({}, commonAccountOptions), options));
                }));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "batchSetAccountAuthKey",
    value: function batchSetAccountAuthKey(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var accountRegistry, batch;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.require({
                  account: true,
                  relayer: true
                });

                accountRegistry = this.contracts.accountRegistry;
                batch = this.modules.batch;
                return _context16.abrupt("return", batch.addToBatch(function (commonAccountOptions) {
                  return accountRegistry.buildSetAccountAuthKeyData(Object.assign(Object.assign({}, commonAccountOptions), options));
                }));

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "batchExecuteAccountTransaction",
    value: function batchExecuteAccountTransaction(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var accountRegistry, batch;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.require({
                  account: true,
                  relayer: true
                });

                accountRegistry = this.contracts.accountRegistry;
                batch = this.modules.batch;
                return _context17.abrupt("return", batch.addToBatch(function (commonAccountOptions) {
                  return accountRegistry.buildExecuteAccountTransactionData(Object.assign(Object.assign({}, commonAccountOptions), options));
                }));

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "batchCommitAccountPaymentChannel",
    value: function batchCommitAccountPaymentChannel(hash) {
      var deposit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var accountRegistry, _this$modules, batch, account, platform, paymentChannel, token, sender, senderSignature, guardianSignature, totalAmount, uid, options;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.require({
                  account: true,
                  relayer: true,
                  platform: true
                });

                accountRegistry = this.contracts.accountRegistry;
                _this$modules = this.modules, batch = _this$modules.batch, account = _this$modules.account;
                platform = this.clients.platform;
                _context18.next = 6;
                return platform.getPaymentChannel({
                  hash: hash
                });

              case 6:
                paymentChannel = _context18.sent;

                if (!(!paymentChannel || paymentChannel.recipient !== account.address)) {
                  _context18.next = 9;
                  break;
                }

                throw new Error('payment channel not found');

              case 9:
                token = paymentChannel.token, sender = paymentChannel.sender, senderSignature = paymentChannel.senderSignature, guardianSignature = paymentChannel.guardianSignature, totalAmount = paymentChannel.totalAmount, uid = paymentChannel.uid;
                options = {
                  uid: uid,
                  sender: sender,
                  senderSignature: senderSignature,
                  guardianSignature: guardianSignature,
                  value: totalAmount,
                  token: token || eth_sdk_1.ZERO_ADDRESS
                };

                if (!deposit) {
                  _context18.next = 15;
                  break;
                }

                return _context18.abrupt("return", batch.addToBatch(function (commonAccountOptions) {
                  return accountRegistry.buildCommitAccountPaymentChannelAndDepositData(Object.assign(Object.assign({}, commonAccountOptions), options));
                }));

              case 15:
                return _context18.abrupt("return", batch.addToBatch(function (commonAccountOptions) {
                  return accountRegistry.buildCommitAccountPaymentChannelData(Object.assign(Object.assign({}, commonAccountOptions), options));
                }));

              case 16:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "estimateBatch",
    value: function estimateBatch() {
      var refundToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var batch;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.require({
                  account: true,
                  relayer: true
                });

                batch = this.modules.batch;
                return _context19.abrupt("return", batch.estimateBatch({
                  refundToken: refundToken
                }));

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "submitBatch",
    value: function submitBatch() {
      var gasPrice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var batch;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.require({
                  account: true,
                  relayer: true
                });

                batch = this.modules.batch;
                return _context20.abrupt("return", batch.submitBatch({
                  gasPrice: gasPrice
                }));

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "resetBatch",
    value: function resetBatch() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.require({
                  account: true,
                  relayer: true
                });

                this.modules.batch.state$.reset();

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "exportPrivateKey",
    // utils
    value: function exportPrivateKey() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this.modules.authKey.exportPrivateKey());

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this.modules.authKey.signPersonalMessage(eth_sdk_1.toHex(message)));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "getBalance",
    value: function getBalance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var result, address, token;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                result = null;
                address = options.address;
                token = options.token;

                if (!address) {
                  address = this.modules.account.address;
                }

                if (!eth_sdk_1.isAddress(address)) {
                  _context24.next = 15;
                  break;
                }

                if (!eth_sdk_1.isAddress(token)) {
                  _context24.next = 11;
                  break;
                }

                _context24.next = 8;
                return this.contracts.token.getBalanceOf(token, address);

              case 8:
                _context24.t0 = _context24.sent;
                _context24.next = 14;
                break;

              case 11:
                _context24.next = 13;
                return this.query.eth.getBalance(address);

              case 13:
                _context24.t0 = _context24.sent;

              case 14:
                result = _context24.t0;

              case 15:
                return _context24.abrupt("return", result);

              case 16:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "subscribeBalance",
    value: function subscribeBalance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var _this = this;

        var result, address, token;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                address = options.address;
                token = options.token;

                if (!address) {
                  address = this.modules.account.address;
                }

                if (eth_sdk_1.isAddress(address)) {
                  result = new utils_1.UniqueSubject();
                  this.state$.block$.hash$.pipe(operators_1.mergeMap(function () {
                    return rxjs_1.from(_this.error$.catchAsyncT(function () {
                      return eth_sdk_1.isAddress(token) ? _this.contracts.token.getBalanceOf(token, address) : _this.query.eth.getBalance(address);
                    }));
                  })).subscribe(result);
                } else {
                  result = new utils_1.UniqueSubject(null);
                  setTimeout(function () {
                    return result.complete();
                  }, 0);
                }

                return _context25.abrupt("return", result);

              case 5:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
    } // protected

  }, {
    key: "bindMethod",
    value: function bindMethod(method) {
      var _this2 = this;

      method = method.bind(this);
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this2.error$.wrapAsyncT(function () {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
            return _regeneratorRuntime.wrap(function _callee26$(_context26) {
              while (1) {
                switch (_context26.prev = _context26.next) {
                  case 0:
                    _context26.next = 2;
                    return this.initialized;

                  case 2:
                    return _context26.abrupt("return", method.apply(void 0, args));

                  case 3:
                  case "end":
                    return _context26.stop();
                }
              }
            }, _callee26, this);
          }));
        });
      };
    }
  }, {
    key: "initialize",
    value: function initialize() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var _this$state, networkVersion, chainId, _this$query, eth, net, accountRegistry, token, _this$modules2, account, block, batch;

        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this$state = this.state, networkVersion = _this$state.networkVersion, chainId = _this$state.chainId;

                if (!(networkVersion || chainId)) {
                  _context27.next = 6;
                  break;
                }

                if (networkVersion && !chainId) {
                  chainId = networkVersion;
                }

                if (!networkVersion && chainId) {
                  networkVersion = chainId;
                }

                _context27.next = 13;
                break;

              case 6:
                _this$query = this.query, eth = _this$query.eth, net = _this$query.net;
                _context27.next = 9;
                return eth.chainId;

              case 9:
                chainId = _context27.sent;
                _context27.next = 12;
                return net.version;

              case 12:
                networkVersion = _context27.sent;

              case 13:
                if (!(!chainId || !networkVersion)) {
                  _context27.next = 15;
                  break;
                }

                throw new Error('invalid network');

              case 15:
                this.state$.update({
                  chainId: chainId,
                  networkVersion: networkVersion
                });
                accountRegistry = new contracts_1.AccountRegistryContract(this);
                token = new contracts_1.TokenContract(this);
                this.contracts = {
                  accountRegistry: accountRegistry,
                  token: token
                };
                _this$modules2 = this.modules, account = _this$modules2.account, block = _this$modules2.block, batch = _this$modules2.batch;
                account.initialize();
                _context27.next = 23;
                return block.initialize();

              case 23:
                _context27.next = 25;
                return batch.initialize();

              case 25:
                this.state$.update({
                  initialized: true
                });

              case 26:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
  }, {
    key: "require",
    value: function require() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var verifyRequire = function verifyRequire(value, condition, error) {
        if (value === true && !condition) {
          throw new Error(error);
        }
      };

      var hasAccount = !!this.state$.account$.value;
      verifyRequire(options.account === true, hasAccount, 'account not connected');
      verifyRequire(options.account === false, !hasAccount, 'account already connected');
      verifyRequire(options.kChannels === true, !!this.clients.kChannels, 'kChannels not configured');
      verifyRequire(options.platform === true, !!this.clients.platform, 'platform not configured');
      verifyRequire(options.relayer === true, !!this.clients.relayer, 'relayer not configured');
    }
  }, {
    key: "state",
    get: function get() {
      return this.state$.getValue();
    }
  }], [{
    key: "create",
    value: function create() {
      var result = null;
      var env;
      var options;
      var basePort;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      env = args[0];
      options = args[1];
      basePort = args[2];

      if (!options) {
        options = {};
      }

      switch (env) {
        case Sdk.Envs.Mainnet:
          result = new Sdk(Object.assign(Object.assign({}, options), defaults_1.MAINNET_SDK_OPTIONS));
          break;

        case Sdk.Envs.Ropsten:
          result = new Sdk(Object.assign(Object.assign({}, options), defaults_1.ROPSTEN_SDK_OPTIONS));
          break;

        case Sdk.Envs.Rinkeby:
          result = new Sdk(Object.assign(Object.assign({}, options), defaults_1.RINKEBY_SDK_OPTIONS));
          break;

        case Sdk.Envs.Goerli:
          result = new Sdk(Object.assign(Object.assign({}, options), defaults_1.GOERLI_SDK_OPTIONS));
          break;

        case Sdk.Envs.Kovan:
          result = new Sdk(Object.assign(Object.assign({}, options), defaults_1.KOVAN_SDK_OPTIONS));
          break;

        case Sdk.Envs.XDai:
          result = new Sdk(Object.assign(Object.assign({}, options), defaults_1.XDAI_SDK_OPTIONS));
          break;

        case null:
          if (!basePort) {
            basePort = 8000;
          }

          result = new Sdk(Object.assign(Object.assign(Object.assign({}, options), defaults_1.LOCAL_SDK_OPTIONS), {
            platformClient: {
              port: basePort + 10
            },
            relayerClient: {
              port: basePort + 20
            }
          }));
          break;
      }

      return result;
    }
  }]);

  return Sdk;
}();

exports.Sdk = Sdk;

(function (Sdk) {
  var Envs;

  (function (Envs) {
    Envs["Mainnet"] = "miannet";
    Envs["Ropsten"] = "ropsten";
    Envs["Rinkeby"] = "rinkeby";
    Envs["Goerli"] = "goerli";
    Envs["Kovan"] = "kovan";
    Envs["XDai"] = "xdai";
  })(Envs = Sdk.Envs || (Sdk.Envs = {}));

  var State$ = /*#__PURE__*/function (_utils_1$StateSubject) {
    _inherits(State$, _utils_1$StateSubject);

    var _super = _createSuper(State$);

    function State$(options) {
      var _this3;

      _classCallCheck(this, State$);

      var state = Object.assign({
        initialized: false,
        chainId: null,
        networkVersion: null,
        networkName: null
      }, options);
      _this3 = _super.call(this, state, {
        prepare: function prepare(previousValue, nextValue) {
          var result = Object.assign(Object.assign({}, previousValue || {}), nextValue);
          var networkName = result.networkName,
              networkVersion = result.networkVersion;

          if (!networkName && networkVersion) {
            result.networkName = utils_1.getNetworkName(networkVersion);
          }

          return result;
        }
      });
      _this3.initialized$ = _this3.getSubSubject('initialized');
      return _this3;
    }

    return State$;
  }(utils_1.StateSubject);

  Sdk.State$ = State$;
})(Sdk = exports.Sdk || (exports.Sdk = {}));